import React from "react";
import { IonCard, IonCardContent } from "@ionic/react";

import { useMutation } from "@apollo/client";
import { useHistory } from "react-router";

import { Breadcrumbs } from "../../../components";

import { COMPLETE_REGISTRATION_MUTATION } from "../../../graphql/mutations/auth.mutation";

import toast from "react-hot-toast";

import "./login.styles.css";

const ResetPassword = () => {
  const history = useHistory();
  const [completeRegistrationMutation] = useMutation(
    COMPLETE_REGISTRATION_MUTATION,
    {
      onCompleted(data) {
        const resp = data.verifyToken;
        if (resp.errors) {
          toast.error(resp.errors[0].message);
        } else {
          toast.success("Email verificata con successo!");
          history.push("/login");
        }
      },
    }
  );

  const breadcrumbEntries = [{ title: "Verifica dell'email" }];

  React.useEffect(() => {
    const resetToken = history?.location?.search;
    const urlParams = new URLSearchParams(resetToken);

    completeRegistrationMutation({
      variables: {
        token: urlParams.get("token"),
      },
    });
  }, []);
  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      <div className="app-page-wrapper flex-center">
        <IonCard
          style={{
            width: "525px",
            padding: "20px",
          }}
        >
          <IonCardContent>
            <p
              className="card-title-text-large mb-default"
              style={{
                marginBottom: "20px",
              }}
            >
              {"Verifica dell'email"}
            </p>
          </IonCardContent>
        </IonCard>
      </div>
    </div>
  );
};

export default ResetPassword;
